// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1275":"3b53517f","3186":"3b53517f","4673":"3b53517f"}[chunkId] + ".chunk.css";
};